@for (item of fundForm.controls; track item; let i = $index) {
  <div [formGroup]="item">
    <div class="row">
      <div class="col col-xs-12">
        <pr-input-column label="Provenance des fonds " [derrors]="derrors">
          <mat-select formControlName="fundOrigin">
            @for (option of options; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12">
        <pr-input-date
          label="Date"
          formControlName="date"
          [derrors]="derrors"
          [isDefault]="false"
        ></pr-input-date>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-radio
          formControlName="repartitionType"
          direction="column"
          [isDefault]="false"
          columns="2"
          [options]="repartitionTypeOptions"
          label="Mode de répartition"
          class="repartition-type-radio"
        >
        </pr-input-radio>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Répartition" [derrors]="derrors">
          <input
            placeholder="Exemple : L5555555L"
            formControlName="distribution"
            type="text"
          />
          <i>{{
            fundForm.controls[i]?.get('repartitionType')?.value === 'AMOUNT'
              ? '€'
              : '%'
          }}</i>
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      @if (fundForm.controls[i]?.get('fundOrigin')?.value === 'OTHER') {
        <div class="col col-xs-12 col-sm-12 col-md-12">
          <pr-input-column
            label="Précisez autre origine des fonds"
            [derrors]="derrors"
          >
            <input formControlName="fundOriginOtherDetail" type="text" />
          </pr-input-column>
        </div>
      }
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column
          label="Description de l'opération à l’origine des fonds à investir"
          [derrors]="derrors"
        >
          <input
            formControlName="description"
            type="text"
            placeholder="Exemple : Prime de résultat"
          />
        </pr-input-column>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Tiers émetteur des fonds" [derrors]="derrors">
          <input
            formControlName="fundEmmiter"
            type="text"
            placeholder="Exemple : Nom de l'employeur"
          />
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column
          label="Établissement financier dépositaire de la somme"
          [derrors]="derrors"
        >
          <input
            formControlName="financialInstitution"
            type="text"
            placeholder="Exemple : Société Générale"
          />
        </pr-input-column>
      </div>
      <div class="col col-xs-12 col-sm-12 col-md-6">
        <pr-input-column label="Provenance des fonds" [derrors]="derrors">
          <mat-select formControlName="source">
            @for (country of countries; track country) {
              <mat-option [value]="country.id">
                {{ country.value }}
              </mat-option>
            }
          </mat-select>
        </pr-input-column>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-3 align-self-center" style="margin-top: 2rem">
        @if (fundForm.length > 1) {
          <pr-button-confirm
            class="confirm"
            display="danger"
            clazz="pr-toolbar-button last"
            icon="delete_outline"
            title="Suppression"
            comment="Toute suppression est définitve, les données seront perdues."
            labelConfirm="Supprimer"
            labelCancel="Annuler"
            (onConfirm)="deleteFields(i)"
          >
            Êtes-vous sûr(e) de vouloir supprimer
          </pr-button-confirm>
        }
      </div>
    </div>
  </div>
}

<div class="row">
  <div class="col col-md-4">
    <pr-button-add
      type="button"
      display="neutral"
      (click)="addFields()"
      label="Ajouter une provenance de fonds"
      rightIcon="+"
    >
    </pr-button-add>
  </div>
</div>
